import 'css-chunksrc/client/pages/milestonePage/styles.scss';export default {
  "milestone": "_milestone_1re5w_1",
  "milestoneLoading": "_milestoneLoading_1re5w_9",
  "loader": "_loader_1re5w_15",
  "loaderMain": "_loaderMain_1re5w_29",
  "main": "_main_1re5w_36",
  "content": "_content_1re5w_43",
  "secondaryCriteria": "_secondaryCriteria_1re5w_49",
  "label": "_label_1re5w_54",
  "row": "_row_1re5w_60",
  "configurationIconBox": "_configurationIconBox_1re5w_71",
  "configurationIcon": "_configurationIcon_1re5w_71",
  "scrollWrapper": "_scrollWrapper_1re5w_89",
  "timeline": "_timeline_1re5w_98",
  "timestamp": "_timestamp_1re5w_105",
  "comments": "_comments_1re5w_113",
  "header": "_header_1re5w_121",
  "contentHeader": "_contentHeader_1re5w_134",
  "title": "_title_1re5w_142",
  "rightContent": "_rightContent_1re5w_150",
  "profileNavigation": "_profileNavigation_1re5w_157",
  "contextualMenu": "_contextualMenu_1re5w_165",
  "contentProjectRedirection": "_contentProjectRedirection_1re5w_173",
  "contentModal": "_contentModal_1re5w_177",
  "constraints": "_constraints_1re5w_184",
  "constraintsText": "_constraintsText_1re5w_192",
  "attachments": "_attachments_1re5w_198",
  "folderIcon": "_folderIcon_1re5w_202",
  "icon": "_icon_1re5w_206",
  "scenePlaceholder": "_scenePlaceholder_1re5w_212"
};